import { Card, Grid, Typography } from '@mui/material'

import { numberFormat } from '../../../../../utils'
import { IOrderReportBucket } from '../types'

interface Props {
  summary?: IOrderReportBucket
}

// value(summary) → รองรับทั้ง field ตรง ๆ และค่า derived (กำไรขั้นต้น = ยอดขาย − ต้นทุน)
// signColor: ใช้สีตามเครื่องหมาย (บวก=น้ำเงิน ลบ=แดง) สำหรับกำไร
const items: {
  key: string
  label: string
  unit: string
  money: boolean
  color: string
  value: (s?: IOrderReportBucket) => number
  signColor?: boolean
}[] = [
  {
    key: 'count',
    label: 'จำนวนออเดอร์',
    unit: 'ออเดอร์',
    money: false,
    color: '#1677ff',
    value: (s) => Number(s?.count ?? 0),
  },
  {
    key: 'quantity',
    label: 'จำนวนชิ้น',
    unit: 'ชิ้น',
    money: false,
    color: '#722ed1',
    value: (s) => Number(s?.quantity ?? 0),
  },
  {
    key: 'codTotal',
    label: 'ยอด COD',
    unit: 'บาท',
    money: true,
    color: '#fa8c16',
    value: (s) => Number(s?.codTotal ?? 0),
  },
  {
    key: 'transferTotal',
    label: 'ยอดโอน',
    unit: 'บาท',
    money: true,
    color: '#13c2c2',
    value: (s) => Number(s?.transferTotal ?? 0),
  },
  {
    key: 'grandTotal',
    label: 'ยอดขายรวม',
    unit: 'บาท',
    money: true,
    color: '#52c41a',
    value: (s) => Number(s?.grandTotal ?? 0),
  },
  {
    key: 'costTotal',
    label: 'ต้นทุนสินค้า',
    unit: 'บาท',
    money: true,
    color: '#eb2f96',
    value: (s) => Number(s?.costTotal ?? 0),
  },
  {
    key: 'grossProfit',
    label: 'กำไรขั้นต้น',
    unit: 'ยอดขาย − ต้นทุน',
    money: true,
    color: '#1677ff',
    value: (s) => Number(s?.grandTotal ?? 0) - Number(s?.costTotal ?? 0),
    signColor: true,
  },
]

const SummaryCards = ({ summary }: Props) => {
  return (
    <Grid container spacing={2} mb={2} columns={{ xs: 1, sm: 2, lg: 7 }}>
      {items.map((item) => {
        const value = item.value(summary)
        const color = item.signColor
          ? value >= 0
            ? '#1677ff'
            : '#cf1322'
          : item.color

        return (
          <Grid item xs={1} key={item.key}>
            <Card
              variant="outlined"
              sx={{
                p: 2,
                height: '100%',
                borderTop: `3px solid ${color}`,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {item.label}
              </Typography>
              <Typography variant="h5" sx={{ mt: 1, fontWeight: 600, color }}>
                {item.money && '฿'}
                {numberFormat(value, item.money ? 2 : 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {item.unit}
              </Typography>
            </Card>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default SummaryCards
